export const visit = (vm, at) => {
at({ "en": { "crm_schema": { "ListSegClassicFamilyNames": { "PAGEVIEW": "Page View", "SUBSCRIPTIONS": "Email Subscription" } } } });
};